module.exports = __webpack_public_path__ + "static/media/nike.2ac1b580.jpg";